import * as React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import type { CustomRouteComponentProps } from 'react-router-dom';
import type { InjectedFormProps } from 'redux-form';
import { Field } from 'redux-form';

import type SaleRequestModel from 'ab-requestModels/sale.requestModel';

import AddressField from 'af-fields/AddressField';
import Input from 'af-fields/Input';

import BackButton from 'af-components/BackButton';
import SubmitButton from 'af-components/SubmitButton';

interface PathParams {
	id?: string;
}

interface OwnProps extends CustomRouteComponentProps<PathParams>, InjectedFormProps<SaleRequestModel> {
	onSubmit: (form: SaleRequestModel) => void;
	companyName: string;
}

type Props = OwnProps;

const SaleForm: React.FC<Props> = (props) => {
	const { handleSubmit, submitting, invalid, form, onSubmit } = props;

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<div className="form-box">
				<Row className="row--padded-top">
					<Col lg={12} md={16}>
						<Field
							component={Input}
							label="Full Name"
							name="fullName"
							placeholder="Enter full name"
							required={true}
							type="text"
						/>
					</Col>
					<Col lg={6} md={8}>
						<Field
							component={Input}
							label="Title"
							name="title"
							placeholder="Enter title"
							required={true}
							type="text"
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6} md={8}>
						<Field
							component={Input}
							label="Email"
							name="email"
							placeholder="Enter email"
							required={true}
							type="text"
						/>
					</Col>
					<Col lg={6} md={8}>
						<Field
							component={Input}
							label="Mobile Phone"
							name="phone"
							placeholder="Enter mobile phone"
							required={true}
							type="tel"
						/>
					</Col>
					<Col lg={6} md={8}>
						<Field
							component={Input}
							label="Fax"
							name="fax"
							placeholder="Enter fax"
							type="tel"
						/>
					</Col>
				</Row>
				<Row>
					<AddressField
						aa1PropName="aa1"
						aa2PropName="aa2"
						aa3PropName="aa3"
						countryPropName="country"
						disableMap={true}
						formName={form}
						latitudePropName="latitude"
						localityPropName="locality"
						locationPropName="street"
						longitudePropName="longitude"
						postalCodePropName="postalCode"
						postalOfficeBoxPropName="postalOfficeBoxCode"
						routePropName="route"
						streetNumberPropName="streetNumber"
						suitePropName="suite"
					/>
				</Row>
				<Row className="row--submit">
					<BackButton />
					<SubmitButton
						disabled={invalid}
						reduxFormSubmitting={submitting}
						variant="primary"
					/>
				</Row>
			</div>
		</Form>
	);
};

export default React.memo(SaleForm);
